import { Component, OnInit, Input } from '@angular/core';
import { DashboardBulkSelection, selectionCount, selectionIds, selectionParams } from '../../../types/dashboard-bulk-selection';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { DataSharingService } from '../../../services/data-sharing.service';
import { AlertsService } from '../../../services/alerts.service';
declare var $: any;

@Component({
    selector: 'mark-as-read-modal',
    templateUrl: './mark-as-read-modal.component.html',
    styleUrls: ['./mark-as-read-modal.component.css'],
    standalone: false
})
export class MarkAsReadModalComponent implements OnInit {
  private readonly destroyed = new Subject<void>();
  selection: DashboardBulkSelection;
  readonly selectionCount = selectionCount;
  @Input('selection') set dashboardSelection(value: DashboardBulkSelection) {
    this.selection = value;
    if (value) { this.companyIds = selectionIds(value); this.searchParams = selectionParams(value); }
  }
  companyIds: Array<any> = [];
  searchParams: HttpParams = null;
  numberOfCompaniesMarkedAsRead = null;

  constructor(
    private alertsService: AlertsService,
    private data: DataSharingService
  ) {}

  isLoading = this.alertsService.isLoading;

  ngOnInit() {
    var markAsUnreadSelf = this;
    $('#markAlertedCompaniesAsReadModal').on('show.bs.modal.bulkAlerts', function (e) {
      markAsUnreadSelf.numberOfCompaniesMarkedAsRead = null;
    });
    $('#markAlertedCompaniesAsReadModal').on('hide.bs.modal.bulkAlerts', function (e) {
      markAsUnreadSelf.numberOfCompaniesMarkedAsRead = null;
    });
    this.data.currentSelectedCompanyIds.pipe(takeUntil(this.destroyed)).subscribe(
      companyIds => { if (!this.selection) this.companyIds = companyIds; }
    );
    this.data.currentSelectedSearchParams.pipe(takeUntil(this.destroyed)).subscribe(
      searchParams => { if (!this.selection) this.searchParams = searchParams; }
    );
  }

  processOutcomeOnBulkMarkingCompaniesAsRead(data): void {
    if (data.success) {
      this.numberOfCompaniesMarkedAsRead = data.number_of_companies_updated;
    }
  }

  markCompaniesAsRead(): void {
    if (this.selection?.mode === 'none') return;
    this.alertsService
      .bulkMarkAlertCompaniesAsRead(this.companyIds, this.searchParams)
      .subscribe(output =>
        this.processOutcomeOnBulkMarkingCompaniesAsRead(output)
      );
  }

  ngOnDestroy(): void {
    this.destroyed.next(); this.destroyed.complete();
    $('#markAlertedCompaniesAsReadModal').off('.bulkAlerts');
  }
}
